module.exports = __webpack_public_path__ + "img/smartTowTicketsBg.f156fa30.png";